import { LinkedInWizardResults } from "@/components/LinkedInWizard/LinkedInWizardResults";
import { useNavigate } from "react-router-dom";

export default function LinkedInWizardSample() {
  const navigate = useNavigate();

  // Sample profile data to showcase the results
  const sampleProfile = {
    userCategories: ["Digital Marketing Strategist", "Content Creator"],
    valueProposition: "helping businesses increase their online presence through data-driven marketing strategies",
    whatYouHelp: "growing businesses",
    targetAudience: "sustainable growth and measurable ROI",
    keywords: "Digital Marketing, SEO, Content Strategy, Social Media Marketing, Analytics",
    voiceStyle: "human-clear",
    industries: ["Technology", "E-commerce", "SaaS"],
    resultsAndProof: "Over the past 5 years, I've helped 50+ companies scale their digital presence, resulting in an average 300% increase in organic traffic and $2M+ in additional revenue. My campaigns have reached over 10 million users and generated consistent 5x ROI.",
    uniqueSellingPoints: ["data-driven insights", "creative storytelling"],
    includeFaith: "no",
    callToAction: "book-call",
    skills: "Marketing Automation, Google Analytics, Facebook Ads, LinkedIn Marketing, Email Marketing",
    targetJobTitles: "Digital Marketing Manager, Growth Marketing Lead, Marketing Director",
    experienceHighlights: [
      {
        role: "Senior Digital Marketing Strategist at TechCorp (2020-Present)",
        achievements: "Led a team of 5 marketers to achieve 250% increase in qualified leads. Implemented AI-driven marketing automation that reduced customer acquisition cost by 40%. Launched successful product campaigns reaching 5M+ users."
      },
      {
        role: "Marketing Manager at GrowthStartup (2018-2020)",
        achievements: "Built marketing department from scratch. Grew social media following from 5K to 100K in 18 months. Created content strategy that increased website traffic by 400%."
      }
    ]
  };

  return (
    <LinkedInWizardResults
      profile={sampleProfile}
      onBack={() => navigate('/linkedin-wizard')}
      onStartOver={() => navigate('/linkedin-wizard')}
      onViewReport={() => console.log('View report clicked')}
    />
  );
}
